export var EVENT = /*#__PURE__*/function (EVENT) {
  EVENT["CREATED"] = "created";
  EVENT["UPDATED"] = "updated";
  EVENT["DELETED"] = "deleted";
  return EVENT;
}({});
export var EVENT_SUBJECT = /*#__PURE__*/function (EVENT_SUBJECT) {
  EVENT_SUBJECT["LINK"] = "link";
  EVENT_SUBJECT["DATASOURCE"] = "datasource";
  return EVENT_SUBJECT;
}({});

/**
 * These are not GASv3 events
 * But they share a similar in shape so that GASv3
 * events can be derived from them / think of them in the same way
 */